import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const ContentLoyalty = () => {
	const classes = useStyles();

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				<img src={Images.icDocument} alt="icDocument" /> Nội dung chương
				trình
			</Grid>
			<Grid classes={{ root: classes.content }}>
				<Grid classes={{ root: classes.text }}>
					Bạn sẽ được tích điểm trên doanh số mua hàng tương ứng với
					<span> Bảng quy đổi điểm.</span>
				</Grid>
				<Grid classes={{ root: classes.text }}>
					Bạn sẽ được đổi quà với các mức điểm tương ứng tại mục{" "}
					<span>Đổi điểm nhận quà.</span>
				</Grid>
				<Grid classes={{ root: classes.text }}>
					Khi có ngành hàng mới nằm ngoài các phân khúc trên, sẽ bổ
					sung thêm cách thức quy đổi điểm của sản phẩm.
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(ContentLoyalty);
